import { render } from "./door.vue?vue&type=template&id=61e88e8c"
import script from "./door.vue?vue&type=script&lang=js"
export * from "./door.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__